module.exports = __webpack_public_path__ + "media/Nature.e4db502a.svg";